import styled from 'styled-components/macro';
import { getFlex } from '../../styled/styleUtils';

export const TemplateConfigWrapper = styled.section`
  /* padding: 1rem; */
  .relOptionsLabel {
    margin-top: 0.5rem;
    margin-bottom: 0.25rem;
  }
  .switch {
    ${getFlex('flex-start', 'center')}
    padding: 0.5rem 0;
    p {
      margin-left: 0.5rem;
    }
  }
  button.reset {
    padding: 0;
  }
`;

export const ColorPickerWrapper = styled.button`
  ${getFlex('space-between', 'stretch')}
  width: 100%;
  background-color: var(--color-white);
  border: 1px dashed var(--color-accent);
  border-radius: 7px;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 1rem;
  padding: 0.5rem 1rem;
  .color {
    width: 40px;
    border-radius: 3px;
    border: 1px solid var(--color-accent);
  }
`;

export const ColorPickerPopover = styled.div`
  background-color: #fff;
  padding: 1rem 0.5rem;
  div.chrome-picker {
    box-shadow: none !important;
    border-radius: 5px !important;
    input {
      font-size: 14px !important;
      border-radius: 5px !important;
      height: 25px !important;
      font-family: var(--font-body) !important;
      font-weight: 500 !important;
      padding: 0.5rem !important;
    }
    label {
      font-size: 14px !important;
      margin-top: 0.5rem !important;
      font-family: var(--font-body) !important;
      font-weight: 500 !important;
    }
    & > div:last-child {
      padding: 1rem 0 !important;
    }
  }
  div.circle-picker {
    margin-left: 0.75rem;
  }
`;
